var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('div',[_c('Title',[_vm._v("Agenda")]),_c('div',_vm._l((_vm.items),function(ref,i){
var to = ref.to;
var title = ref.title;
var date = ref.date;
var local = ref.local;
return _c('div',{key:i},[_c('Schedule',{attrs:{"to":to,"title":title,"date":date,"local":local}})],1)}),0)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }